/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Confirmdeletetitle2Inputs */

const zh_danger_confirmdeletetitle2 = /** @type {(inputs: Danger_Confirmdeletetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认删除账户`)
};

const en_danger_confirmdeletetitle2 = /** @type {(inputs: Danger_Confirmdeletetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Account Deletion`)
};

const es_danger_confirmdeletetitle2 = /** @type {(inputs: Danger_Confirmdeletetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar eliminación de cuenta`)
};

/**
* | output |
* | --- |
* | "Confirm Account Deletion" |
*
* @param {Danger_Confirmdeletetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_confirmdeletetitle2 = /** @type {((inputs?: Danger_Confirmdeletetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Confirmdeletetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_confirmdeletetitle2(inputs)
	if (locale === "en") return en_danger_confirmdeletetitle2(inputs)
	return es_danger_confirmdeletetitle2(inputs)
});
export { danger_confirmdeletetitle2 as "danger_confirmDeleteTitle" }